export default {
  evaluation_dashboard: {
    title: '委托评估仪表板',
    unit: ' 公司',
    average: '平均分:',
    point: ' 点',
    answered_label: '已答复',
    evaluated_label: '已完成评估',
    corporate_average: '委托评估公司的平均',
    points_earned_by_companies: '委托评估公司的得分分布情况',
    year_modal: {
      title: '请选择年份。',
      label: '年份',
    },
    response_status_title: '回答状态分布',
    response_status_rating_nothing: '没有公司完成ESG评级评估。',
    esg_rating_title: 'ESG评级分布',
    esg_score_title: 'ESG得分分布',
    category_scores_title: '按类别比较得分',
    category_scores_distribution_title: '按类别的得分分布',
    category_score_data_all_label: 'ASUENE ESG整体的平均',
    esg_scores_by_industry_title: '各行业的ESG得分分布',
    environment_score_title: '环境得分分布',
    social_score_title: '社会得分分布',
    governance_score_title: '管理得分分布',
    environment_score_subtitle_upper5: '环境得分 前5名的公司',
    environment_score_subtitle_lower5: '环境得分 后5名的公司',
    social_score_subtitle_upper5: '社会得分 前5名的公司',
    social_score_subtitle_lower5: '社会得分 后5名的公司',
    governance_score_subtitle_upper5: '管理得分 前5名的公司',
    governance_score_subtitle_lower5: '管理得分 后5名的公司',
    // empty_error_message: "",
    common: {
      companies: ' 公司',
      update_date: '更新日期',
    },
    registration_rate: {
      title: '注册率',
      tip: '在Asuene ESG注册的被评估企业数与被调查公司数之比',
    },
    answer_rate: {
      title: '回答率',
      tip: '提交回答的被评估企业数与被调查公司数之比',
    },
    days_remaining: {
      title: '距调查结束的天数',
      tip: '距已设置的回答截止时间的天数\n如果您想更改回答截止时间，请联系我们。',
      days_remaining_before: '还剩',
      days_remaining_after: '天',
      expired: '回答截止时间已过',
    },
    answer_transition: {
      title: '回答进展',
      companies_submitted: '回答公司数',
      breakdown: '明细',
      unregistered: '未注册',
      total: '共计',
      number_of_companies: '公司数',
    },
    answer_list: {
      title: '最新回答数据',
      submitted_at: '回答日期',
    },
  },
}
